import * as types from '../../mutation-types'
import donations from '../../../api/donations'
import { get } from 'lodash'

const getRandomRequestId = () => Math.ceil(+new Date() / 1000) % 1000000

const state = {
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
    connectionError: true
  },
  requestTypes: {
  },
  isTerminalAvailable: false,
  activeTID: null,
  availableTerminals: [],
  PSSaleRequested: false,
  terminalNotificationStatus: 'IDLE',
  PSSaleRequestStatus: null,
  donationRequestError: null,
  declineSignatureRequiredTransaction: false,
  declineSignatureRequiredTransactionId: -1,
  eodReports: {},
  isTerminalAvailableAfterRequest: true,
  pageRedirectKey: false,
  PSSaleRequestResponse: {}
}

const getters = {
  isConnected: () => state.socket.isConnected,
  isTerminalAvailable: () => state.isTerminalAvailable,
  availableTerminals: () => state.availableTerminals,
  activeTID: () => state.activeTID || localStorage.getItem('user-store-activeTID') || null,
  PSSaleRequested: () => state.PSSaleRequested,
  terminalNotificationStatus: () => state.terminalNotificationStatus,
  PSSaleRequestStatus: () => state.PSSaleRequestStatus,
  PSSaleRequestResponse: () => state.PSSaleRequestResponse,
  connectionError: () => state.socket.connectionError,
  donationRequestError: () => state.donationRequestError,
  declineSignatureRequiredTransaction: () => state.declineSignatureRequiredTransaction,
  declineSignatureRequiredTransactionId: () => state.declineSignatureRequiredTransactionId,
  eodReports: () => state.eodReports,
  isTerminalAvailableAfterRequest: () => state.isTerminalAvailableAfterRequest,
  pageRedirectKey: () => state.pageRedirectKey
}

const actions = {
  setActiveTID ({ commit }, {tpi, tid}) {
    commit(types.PS_SET_TID, { tid: tid || tpi })
  },
  resetTerminalNotificationStatus ({commit}) {
    commit(types.TERMINAL_NOTIFICATION_STATUS, 'Please wait')
  },
  resetPSSaleRequestStatus ({ commit }) {
    commit(types.PS_SALE_REQUEST_STATUS, null)
  },
  updatePaymentRequestStatus ({ commit }, {id, status}) {
    commit(types.TERMINAL_NOTIFICATION_STATUS, status)
    return donations.updatePaymentRequest({
      status,
      donationId: id
    })
  },
  declineSignatureVerification ({commit}, {socket}) {
    if (getters.isConnected() && getters.declineSignatureRequiredTransactionId() !== -1) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'id': getters.declineSignatureRequiredTransactionId(),
        'result': { 'accepted': false }
      })
      commit(types.DECLINED_SIGNATURE_VERIFICATION_STATUS)
    }
  },
  requestTerminalDetails ({ commit }, { socket, terminals }) {
    const type = types.WS_GET_TERMINAL_DETAILS
    const requestId = getRandomRequestId()
    commit('SET_TERMINAL_AVAILABLE_STATUS', {status: false})
    commit(types.WS_ADD_REQUEST_TYPE, { requestId, type })

    if (getters.isConnected()) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'method': 'terminalsDetails',
        'params': {
          'tpiList': terminals.map(t => t.tid),
          'status': 'AVAILABLE'
        },
        'id': requestId
      })
    } else {
      console.warn('Called before socket is available.')
    }
  },
  updateDonationRequest (_, response) {
    response = response || state.PSSaleRequestResponse
    return donations.updatePaymentRequest({
      status: get(response, 'transactionResult', 'FAILED'),
      ps_reference: response.transactionId || 'NA',
      ps_response: response || {},
      terminalId: getters.activeTID(),
      donationId: response.id
    })
  },
  requestPayment ({ commit }, { amount, type, socket }) {
    commit(types.LOADING_START)
    return donations.requestPayment({ amount, type, terminalId: getters.activeTID() })
    .then((res) => {
      if (res.status === 'Success') {
        let result = res.data
        const requestId = result.id
        const type = types.WS_PS_SALE
        commit(types.PAYMENT_REQUESTED, true)
        commit(types.WS_ADD_REQUEST_TYPE, { requestId, type })
        if (getters.isConnected()) {
          socket.sendObj({
            'jsonrpc': '2.0',
            'method': 'sale',
            'params': {
              'tpi': getters.activeTID(),
              'currency': 'GBP',
              'amount': amount * 100
            },
            'id': requestId
          })

          actions.updateDonationRequest({}, {transactionResult: 'RequestInitiated', id: requestId})
        } else {
          // console.warn('Called before socket is available.')
          commit(types.LOADING_END)
          commit(types.DONATION_REQUEST_FAILED, res.message)
        }
      } else {
        commit(types.LOADING_END)
        commit(types.DONATION_REQUEST_FAILED, res.errors)
      }
    })
    .catch(error => {
      // TODO: handle if socket is not connected.
      commit(types.LOADING_END)
      console.warn(error.message)
      commit(types.DONATION_REQUEST_FAILED, error.message)
    })
    .finally(() => {
      // commit(types.LOADING_END)
    })
  },

  eodReportRequest ({ commit }, { socket, tid }) {
    commit(types.LOADING_START)
    const type = types.EODREPORTS_REQUEST
    const requestId = getRandomRequestId()
    // commit(types.EODREPORTS_REQUEST, true)
    commit(types.WS_ADD_REQUEST_TYPE, { requestId, type })
    if (getters.isConnected()) {
      socket.sendObj({
        'jsonrpc': '2.0',
        'method': 'reportEndOfDay',
        'params': {
          'tpi': tid
        },
        'id': requestId
      })
    } else {
      // console.warn('Called before socket is available.')
      commit(types.EODREPORTS_REQUEST_FAILURE, 'No Connection')
    }
  },
  pageRedirect ({ commit }, val) {
    commit(types.PAGE_REDIRECT, val)
  }
}

const mutations = {
  SET_TERMINAL_AVAILABLE_STATUS (state, {status}) {
    state.isTerminalAvailable = status
  },
  [types.PAGE_REDIRECT] (state, val) {
    state.pageRedirectKey = val
  },
  [types.PS_SALE_REQUEST_STATUS] (state, status) {
    state.PSSaleRequestStatus = status
  },
  [types.PS_SET_TID] (state, { tid }) {
    state.activeTID = tid
    localStorage.setItem('user-store-activeTID', tid)
  },
  [types.PS_SALE_REQUESTED] (state, s) {
    state.PSSaleRequested = s
  },
  [types.WS_ADD_REQUEST_TYPE] (state, { requestId, type }) {
    state.requestTypes[requestId] = type
  },
  [types.DONATION_REQUEST_FAILED] (state, reason) {
    state.donationRequestError = reason
  },
  [types.TERMINAL_NOTIFICATION_STATUS] (state, val) {
    state.terminalNotificationStatus = val
  },
  SOCKET_ONOPEN (state, event) {
    state.socket.isConnected = true
  },
  SOCKET_ONCLOSE (state, event) {
    state.socket.isConnected = false
  },
  SOCKET_ONERROR (state, event) {
    state.socket.isConnected = false
    state.socket.connectionError = true
  },
  [types.DECLINED_SIGNATURE_VERIFICATION_STATUS] (state) {
    state.declineSignatureRequiredTransaction = false
    state.declineSignatureRequiredTransactionId = -1
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE (state, message) {
    state.message = message
    const { id, result = {}, error } = message
    if (error) {
      state.isTerminalAvailableAfterRequest = false
    }
    if (id && state.requestTypes[id]) {
      switch (state.requestTypes[id]) {
        case types.WS_GET_TERMINAL_DETAILS:
          state.availableTerminals = result
          state.isTerminalAvailable = true
          if (result.length === 0) {
            state.isTerminalAvailableAfterRequest = false
          }
          delete state.requestTypes[id]
          break

        case types.WS_PS_SALE:
          state.PSSaleRequested = true
          state.PSSaleRequestResponse = {...result, id}

          if (result.transactionResult === 'SUCCESSFUL') {
            state.PSSaleRequestStatus = true
          } else {
            state.PSSaleRequestStatus = false
            console.log(message)
          }

          delete state.requestTypes[id]
          state.terminalNotificationStatus = result.transactionResult || 'TIMED_OUT'
          break

        case types.EODREPORTS_REQUEST:
          state.eodReports = result.transactionResult ? result : message
          break

        default:
          break
      }
    } else if (message.method === 'terminalNotification') {
      state.PSSaleRequested = true
      state.terminalNotificationStatus = message.params.notificationValue
    } else if (message.method === 'signatureVerificationRequest') {
      state.declineSignatureRequiredTransaction = true
      state.declineSignatureRequiredTransactionId = message.id
    }
  },
  // mutations for reconnect methods
  SOCKET_RECONNECT (state, count) {
    state.socket.isConnected = false
    state.socket.connectionError = false

    console.info(state, count)
  },
  SOCKET_RECONNECT_ERROR (state) {
    window.location.reload()
    state.socket.connectionError = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/socket/index.js